import { render, staticRenderFns } from "./BaseBar.vue?vue&type=template&id=6b8e1e44&"
import script from "./BaseBar.vue?vue&type=script&lang=ts&"
export * from "./BaseBar.vue?vue&type=script&lang=ts&"
import style0 from "./BaseBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports